import { USERPROFILE } from '../actionTypes';

const initialState = {
  content: [],
  userDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USERPROFILE.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case USERPROFILE.SET_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };
    default:
      return state;
  }
};
